import * as React from 'react'
import ReactSelect, {OnChangeHandler, Option, Options, OptionValues, ReactSelectProps} from 'react-select'
import 'react-select/dist/react-select.css'

class ReactSelectNumber extends ReactSelect<number|string>{}

export const Chosen = (props: ReactSelectProps<number|string>) => {
	return <ReactSelectNumber {...props}/>
}

export type ChosenOption<T extends OptionValues> = Option<T> & {value: T}
export type ChosenOptions<T extends OptionValues> = Array<ChosenOption<T>>

type SetOptionsHandler<T extends OptionValues> = (o: T[]) => void
export const onChangeHandler = <T extends OptionValues>(h: SetOptionsHandler<T>): OnChangeHandler<T> => {
	return (selectedOptions) => {
		if(isOptions(selectedOptions)) {
			const validSelectedOptions = validateOptions(selectedOptions)
			h(validSelectedOptions.map((o) => o.value))
		}
	}
}

type OptionOrOptions<T extends OptionValues> = Option<T>|Options<T>|null
export const isOptions = <T extends OptionValues>(o: OptionOrOptions<T>): o is Options<T> => {
	return o !== null && Array.isArray(o)
}

export const validateOptions = <T extends OptionValues>(os:Options<T>):ChosenOptions<T> => {
	return os.filter<ChosenOption<T>>((o): o is ChosenOption<T> => o.value !== undefined)
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/chosen.tsx